class CanvasUtils {
  static drawRoundRectPath(ctx, width, height, radius) {
    ctx.beginPath()
    ctx.arc(width - radius, height - radius, radius, 0, Math.PI / 2)
    ctx.lineTo(radius, height)
    ctx.arc(radius, height - radius, radius, Math.PI / 2, Math.PI)
    ctx.lineTo(0, radius)
    ctx.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2)
    ctx.lineTo(width - radius, 0)
    ctx.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2)
    ctx.lineTo(width, height - radius)
    ctx.closePath()
  }

  static fillRoundRect(ctx, x, y, width, height, radius, fillColor = '#fff') {
    if (2 * radius > width || 2 * radius > height) {
      return false
    }

    ctx.save()
    ctx.translate(x, y)
    this.drawRoundRectPath(ctx, width, height, radius)
    if (typeof fillColor === 'string') {
      ctx.fillStyle = fillColor
    } else {
      const linearGradient = ctx.createLinearGradient(x, y, width, height)
      for (const item of fillColor) {
        linearGradient.addColorStop(...item)
      }
      ctx.fillStyle = linearGradient
    }
    ctx.fill()
    ctx.restore()
  }

  static drawRadiusImg(ctx, img, x, y, w, h, r) {
    ctx.save()
    if (w < 2 * r) r = w / 2
    if (h < 2 * r) r = h / 2
    ctx.beginPath()
    ctx.moveTo(x + r, y)
    ctx.arcTo(x + w, y, x + w, y + h, r)
    ctx.arcTo(x + w, y + h, x, y + h, r)
    ctx.arcTo(x, y + h, x, y, r)
    ctx.arcTo(x, y, x + w, y, r)
    ctx.closePath()
    ctx.strokeStyle = '#ffffff'
    ctx.stroke()
    ctx.clip()
    ctx.drawImage(img, x, y, w, h)
    ctx.restore()
  }

  static drawText(ctx, text, x, y, fontObj, maxWidth, maxRow, lineHeight = 1.5) {
    ctx.beginPath()
    ctx.font = `${fontObj.fontWeight || 'normal'} ${fontObj.fontSize}px ${fontObj.fontFamily || 'Outfit, SourceHanSansSC'}`
    ctx.fillStyle = fontObj.color

    if (fontObj.textAlign) {
      switch (fontObj.textAlign) {
        case 'center':
          x -= ctx.measureText(text).width / 2
          break
        case 'right':
          x -= ctx.measureText(text).width
          break
      }
    }

    if (maxWidth && maxRow && lineHeight) {
      let temp = ''
      const row = []
      text = text.replace(/[\r\n]/g, '')
      const arr = text.split('')

      if (ctx.measureText(text).width < maxWidth) {
        row.push(text)
      } else {
        for (let i = 0; i < arr.length; i++) {
          if (row.length === maxRow && i <= arr.length - 1) {
            row[row.length - 1] += '...'
            break
          }
          if (ctx.measureText(temp).width < maxWidth) {
            temp += arr[i]
            if (i === arr.length - 1) {
              row.push(temp)
            }
          } else {
            i--
            row.push(temp)
            temp = ''
          }
        }
      }

      row.forEach((line, i) => {
        let lineX = x
        if (fontObj.textAlign === 'center') {
          lineX -= ctx.measureText(line).width / 2
        } else if (fontObj.textAlign === 'right') {
          lineX -= ctx.measureText(line).width
        }
        ctx.fillText(line, lineX, y + i * lineHeight, maxWidth)
      })
    } else {
      ctx.fillText(text, x, y)
    }
    ctx.closePath()
  }

  static loadImg(url) {
    return new Promise((resolve) => {
      const img = new Image()
      img.setAttribute('crossOrigin', 'anonymous')
      img.src = url
      img.onload = () => resolve(img)
    })
  }

  static loadAllImg(imgList) {
    return Promise.all(imgList.map(this.loadImg))
  }

  static async drawFromConfig(config) {
    const pixelRatio = Math.max(window.devicePixelRatio || 1, 2)
    const canvas = document.createElement('canvas')
    canvas.width = config.width * pixelRatio
    canvas.height = config.height * pixelRatio
    canvas.style.width = `${config.width}px`
    canvas.style.height = `${config.height}px`
    canvas.style.display = 'none'
    document.body.appendChild(canvas)

    const ctx = canvas.getContext('2d')
    if (!ctx) {
      throw new Error('无法获取 CanvasRenderingContext2D')
    }
    ctx.scale(pixelRatio, pixelRatio)

    for (const item of config.config) {
      switch (item.type) {
        case 'rect':
          this.fillRoundRect(ctx, item.x, item.y, item.width, item.height, item.borderRadius, item.bgColor)
          break
        case 'img': {
          const img = await this.loadImg(item.src)
          if (item.borderRadius) {
            this.drawRadiusImg(ctx, img, item.x, item.y, item.width, item.height, item.borderRadius)
          } else {
            ctx.drawImage(img, item.x, item.y, item.width, item.height)
          }
          break
        }
        case 'text':
          this.drawText(
            ctx,
            item.text,
            item.x,
            item.y,
            {
              fontSize: item.fontSize,
              color: item.color,
              textAlign: item.textAlign,
              fontWeight: item.fontWeight,
              fontFamily: item.fontFamily
            },
            item.maxWidth,
            item.maxRow,
            item.lineHeight
          )
          break
        default:
          break
      }
    }

    return new Promise((resolve) => {
      resolve(canvas.toDataURL('image/png', config.quality || 1))
      document.body.removeChild(canvas)
    })
  }
}

export default CanvasUtils
